'use client';

import { Button as HeroButton, type ButtonProps as HeroButtonProps } from '@heroui/react';
import * as React from 'react';

export interface ButtonProps extends Omit<HeroButtonProps, 'color' | 'variant'> {
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'link';
  size?: 'sm' | 'md' | 'lg';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'default', size = 'md', ...props }, ref) => {
    // Map custom variants to HeroUI props
    const variantMap: Record<
      string,
      { color?: HeroButtonProps['color']; variant?: HeroButtonProps['variant'] }
    > = {
      default: { color: 'danger', variant: 'solid' },
      secondary: { color: 'primary', variant: 'solid' },
      outline: { variant: 'bordered' },
      ghost: { variant: 'light' },
      link: { variant: 'light' },
    };

    const { color, variant: heroVariant } = variantMap[variant] || variantMap.default;

    return <HeroButton ref={ref} color={color} variant={heroVariant} size={size} {...props} />;
  }
);
Button.displayName = 'Button';

export { Button };
